<section class="row registrationView pl-3" id="productList-area">
  <section
    class="col-md-12 col-sm-8 pay-section float-left account-reg-section"
    >
    @if (header === 'billingDetails') {
      <app-billing-information
        (shippingDataSet)="onheaderPassing($event)"
        [formDetails]="formData"
        [multipleFormData]="twoFormsData"
      ></app-billing-information>
    }

    <!-- Shipping page form starts  -->
    @if (header === 'shippingDetails') {
      <app-shipping-information
        (pageHeader)="onheaderPassing($event)"
        [formDetails]="formData"
        [multiFormData]="twoFormsData"
      ></app-shipping-information>
    }
    <!-- shipping form ends -->

    @if (header === 'contacts') {
      <app-contacts-information
        (pageHeader)="onheaderPassing($event)"
        [formDetails]="formData"
        [multiFormData]="twoFormsData"
      ></app-contacts-information>
    }
  </section>
</section>
